import { LightbulbIcon } from './LightbulbIcon';

/**
 * author: Google
 * id ECC94305-DFA6-4D9B-85C8-CC79F3F05FB5
 * name lightbulb
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb.svg
 * tags
 * - Home Automation 
 */
export const IdeaIcon = LightbulbIcon;
export default IdeaIcon